// Awaiting Documents filters
//
// brokerIds and entityIds are both seeded once by the page on first load: the
// signed-in broker's own id, and every entity except Servca USA. Persisting them
// here means the seed happens once per session rather than on every navigation
// back to the page, so clearing either filter actually sticks.
//
// documentType is deliberately not seeded. Blank means both Insurer Produced and
// Servca Produced, which is the whole list — defaulting it to either one would put
// back the hidden backlog this page was rebuilt to surface.
const getDefaultState = () => {
	return {
		filters: {
			query: "",
			brokerIds: [],
			entityIds: [],
			documentType: "",
			status: "",
			sortBy: "waiting",
			currentPage: 0,
			seeded: false,
		},
	}
}

export const state = () => getDefaultState()

export const mutations = {
	RESET_STATE(state) {
		Object.assign(state, getDefaultState())
	},
	SET_FILTER(state, { filterName, value }) {
		state.filters[filterName] = value
	},
}

export const actions = {
	reset({ commit }) {
		commit("RESET_STATE")
	},
	updateFilter({ commit }, { filterName, value }) {
		commit("SET_FILTER", { filterName, value })
	},
}

export const getters = {
	getFilters(state) {
		return state.filters
	},
	getFilter: (state) => (filterName) => {
		return state.filters[filterName]
	},
}
